export default __webpack_public_path__ + "static/media/logo.e4906fd3.png";